<template>
  <div id="SearchProducts">
    <h2>{{ $t("variables.PinkfongProducts")}} ({{ pinkfongProductCount }})</h2>
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <list
      :items="pinkfongProductList"
      model-name="pinkfongproducts"
      :flex-class="'pa-3'"
      :list-break-point="pinkfongBreakpoint"
    >
      <template slot-scope="props">
        <h3>{{ props.item.name }}</h3>
        <div class="mt-1">
          Item Code: {{ props.item.uid }}<br>
          <div v-if="isKorean()">
            {{ $t("variables.price") }}: {{ $t("variables.currencyCode") }}{{ Number(props.item.price).toLocaleString() }}
          </div>
        </div>
        <v-btn
          style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
          @click.stop="linkTo(getDetailUrl('pinkfongproducts', props.item))"
        >
          {{ $t("variables.viewDetail") }}
        </v-btn>
      </template>
    </list>
    <div
      v-if="loadingMore.pinkfongproducts"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div class="show-more">
      <v-btn
        v-if="pinkfongProductNext && !loadingMore.pinkfongproducts"
        @click="loadMoreItems('pinkfongproducts')"
      >
        {{ $t('newLP.more') }} <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </div>
    <h2>{{ $t("variables.LicensedProducts") }} ({{ licenseProductCount }})</h2>
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <list
      :items="licenseProductList"
      model-name="licensedproducts"
      :flex-class="'pa-3'"
      :list-break-point="licenceBreakpoint"
    >
      <template slot-scope="props">
        <h3>{{ props.item.name }}</h3>
        <div class="mt-1">
          {{ props.item.category.name }} ({{ props.item.age }})<br>
          {{ $t("variables.manufacturer") }}: {{ props.item.manufacturer }}
        </div>
        <v-btn
          style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
          @click.stop="linkTo(getDetailUrl('licensedproducts', props.item))"
        >
          {{ $t("variables.viewDetail") }}
        </v-btn>
      </template>
    </list>
    <div
      v-if="loadingMore.licensedproducts"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div class="show-more">
      <v-btn
        v-if="licenseProductNext && !loadingMore.licensedproducts"
        @click="loadMoreItems('licensedproducts')"
      >
        {{ $t('newLP.more') }} <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </div>
    <h2>{{ $t("variables.MediaContent") }} ({{ mediaContentCount }})</h2>
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <list
      :items="mediaContentList"
      model-name="mediacontent"
      :flex-class="'pa-3'"
      :list-break-point="mediaBreakpoint"
    >
      <template slot-scope="props">
        <h3>{{ props.item.name }}</h3>
        <div class="mt-1">
          {{ $t("variables.contentLanguage") }}: {{ props.item.content_language }}<br>
          {{ $t("variables.seriesKnitting") }}: {{ props.item.contents_quantity }} X {{ props.item.video }}
        </div>
        <v-btn
          style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
          @click.stop="linkTo(getDetailUrl('mediacontent', props.item))"
        >
          {{ $t("variables.viewDetail") }}
        </v-btn>
      </template>
    </list>
    <div
      v-if="loadingMore.mediacontent"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div class="show-more">
      <v-btn
        v-if="mediaContentNext && !loadingMore.mediacontent"
        @click="loadMoreItems('mediacontent')"
      >
        {{ $t('newLP.more') }} <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import List from 'components/List.vue'

export default {
  components: {
    'list': List
  },
  data () {
    return {
      pinkfongProductList: [],
      licenseProductList: [],
      mediaContentList: [],
      pinkfongProductCount: 0,
      licenseProductCount: 0,
      mediaContentCount: 0,
      pinkfongProductNext: null,
      licenseProductNext: null,
      mediaContentNext: null,
      loading: true,
      loadingMore: {
        pinkfongproducts: false,
        licensedproducts: false,
        mediacontent: false
      }
    }
  },
  computed: {
    pinkfongBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    licenceBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    mediaBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 6,
        'lg': 6,
        'xl': 6
      }
    }
  },
  watch: {
    '$route.query.value': function () {
      this.initSearchProducts()
    }
  },
  beforeMount () {
    this.initSearchProducts()
  },
  methods: {
    initSearchProducts: function () {
      this.loading = true
      this.getSearchProducts()
    },
    getSearchProducts: function () {
      let queryValue = this.$route.query.value
      if (!this.$route.params.lang) {
        this.$route.params.lang = this.$language.locale
      }
      this.$http.get('/api/products/search/?q=' + queryValue, { params: this.$route.params })
        .then(response => {
          this.pinkfongProductList = [ ...response.data.pinkfongproducts.results ]
          this.licenseProductList = [ ...response.data.licensedproducts.results ]
          this.mediaContentList = [ ...response.data.mediacontent.results ]

          this.pinkfongProductCount = response.data.pinkfongproducts.count
          this.licenseProductCount = response.data.licensedproducts.count
          this.mediaContentCount = response.data.mediacontent.count

          this.pinkfongProductNext = response.data.pinkfongproducts.next
          this.licenseProductNext = response.data.licensedproducts.next
          this.mediaContentNext = response.data.mediacontent.next

          this.loading = false
        })
        .catch(err => {
          console.error(err)
        })
    },
    getDetailUrl (product, item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/' + product + '/' + category + '/' + item.code
    },
    async loadMoreItems (product) {
      this.loadingMore[product] = true

      let listKey, nextKey
      switch (product) {
        case 'pinkfongproducts':
          listKey = 'pinkfongProductList'
          nextKey = 'pinkfongProductNext'
          break
        case 'licensedproducts':
          listKey = 'licenseProductList'
          nextKey = 'licenseProductNext'
          break
        case 'mediacontent':
          listKey = 'mediaContentList'
          nextKey = 'mediaContentNext'
          break
        default: break
      }
      if (!this[nextKey]) return

      const { data } = await this.$http.get(this[nextKey])

      this[listKey] = this[listKey].concat(data[product].results)
      this[nextKey] = data[product].next
      this.loadingMore[product] = false
    },
    linkTo (address) {
      this.$router.push(address)
    }
  }
}
</script>

<style>
  .show-more{
    width: 100%;
    padding: 30px 15px 50px;
    text-align: center;
  }

  .show-more button {
    width: 100%;
    background-color: #ffec8b !important;
    border-radius: 20px !important;
    margin: 0px !important;
    padding: 0px !important;
    font-size: 16px;
    font-weight: bold;
    color: #3a3a3acf !important;
  }

  .show-more i {
    position: relative;
    top: -2px;
  }
</style>



// WEBPACK FOOTER //
// src/app/contents/SearchProducts.vue